(function ($) {
	if (typeof $.fn.niceSelect !== 'function') {
		return;
	}
	// Initialize nice select for custom selects
	$('select.custom-select').niceSelect();

	// Add icons to dropdown options after nice select initialization
	$('select.custom-select').each(function () {
		const $select = $(this);
		const $niceSelect = $select.next('.nice-select');

		// Check if this select has any options with data-icon
		if ($select.find('option[data-icon]').length > 0) {
			$niceSelect.find('.option').each(function () {
				const $option = $(this);
				const originalOption = $select.find('option').eq($option.index());
				const iconUrl = originalOption.attr('data-icon');

				if (iconUrl && iconUrl !== '' && !$option.find('.option-icon').length) {
					$option.prepend(
						`<img src="${iconUrl}" alt="" class="option-icon" style="width: 36px; height: 36px; margin-right: 8px; vertical-align: middle;" />`,
					);
				}
			});
		}
	});

	// Trigger change events on original select when NiceSelect changes
	$('.nice-select').on('click', '.option', function () {
		const $niceSelect = $(this).closest('.nice-select');
		const $originalSelect = $niceSelect.prev('select')[0]; // Get DOM element, not jQuery object

		// Trigger change event on the original select element using vanilla JS
		setTimeout(function () {
			const event = new Event('change', { bubbles: true });
			$originalSelect.dispatchEvent(event);
		}, 50); // Small delay to ensure NiceSelect has updated the value
	});
})(jQuery);
